// 梯控设备
const ladderControlSbJurisdiction = [
  { id: "009001001", label: "添加设备", children: [] },
  { id: "009001002", label: "删除设备", children: [] },
  { id: "009001003", label: "修改设备", children: [] }
];

// 电梯管理
const ladderControlDtJurisdiction = [
  { id: "009002001", label: "添加电梯", children: [] },
  { id: "009002002", label: "删除电梯", children: [] },
  { id: "009002003", label: "修改电梯", children: [] }
];

// 授权管理
const ladderControlSqJurisdiction = [
  { id: "009003001", label: "添加授权", children: [] },
  { id: "009003002", label: "删除授权", children: [] },
  { id: "009003003", label: "修改授权", children: [] }
];

// 限制乘梯
const elevatorBlackListJurisdiction = [
  { id: "009004001", label: "添加", children: [] },
  { id: "009004002", label: "删除", children: [] }
];

// 梯控计划
const ladderControlPlantJurisdiction = [
  { id: "009006001", label: "添加计划", children: [] },
  { id: "009006002", label: "修改计划", children: [] },
  { id: "009006003", label: "删除计划", children: [] }
];

// 设备状态日志
const ladderDeviceStatusLogJurisdiction = [
  { id: "009007001", label: "导出", children: [] }
];

// 智慧梯控
const ladderControlJurisdictionChildren = [
  {
    id: "009009000",
    label: "概览",
    routerName: "ladder-over-view",
    children: []
  },
  {
    id: "009001000",
    label: "设备管理",
    routerName: "ladder-device",
    children: ladderControlSbJurisdiction
  },
  {
    id: "009002000",
    label: "电梯管理",
    routerName: "elevator",
    children: ladderControlDtJurisdiction
  },
  {
    id: "009003000",
    label: "授权管理",
    routerName: "elevator-authorize",
    children: ladderControlSqJurisdiction
  },
  {
    id: "009004000",
    label: "限制乘梯",
    routerName: "elevator-black-list",
    children: elevatorBlackListJurisdiction
  },
  {
    id: "009006000",
    label: "梯控计划",
    routerName: "ladder-plant-manage",
    children: ladderControlPlantJurisdiction
  },
  {
    id: "009005000",
    label: "识别记录",
    routerName: "identification-record",
    children: []
  },
  {
    id: "009007000",
    label: "设备状态日志",
    routerName: "ladder-device-status-log",
    children: ladderDeviceStatusLogJurisdiction
  },
  {
    id: "009008000",
    label: "操作日志",
    routerName: "ladder-control-log",
    children: []
  }
];

const ladderControlJurisdiction = {
  id: "009",
  label: "智慧梯控",
  children: ladderControlJurisdictionChildren
};

export { ladderControlJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/ladderControlJurisdiction.js